__turbopack_context__.v({
  "currentRefinementsCategory": "Header-module-scss-module__1psOOq__currentRefinementsCategory",
  "currentRefinementsCategoryV2": "Header-module-scss-module__1psOOq__currentRefinementsCategoryV2",
  "currentRefinementsDelete": "Header-module-scss-module__1psOOq__currentRefinementsDelete",
  "currentRefinementsDeleteV2": "Header-module-scss-module__1psOOq__currentRefinementsDeleteV2",
  "currentRefinementsItem": "Header-module-scss-module__1psOOq__currentRefinementsItem",
  "currentRefinementsLabel": "Header-module-scss-module__1psOOq__currentRefinementsLabel",
  "currentRefinementsList": "Header-module-scss-module__1psOOq__currentRefinementsList",
  "dealsGridSection": "Header-module-scss-module__1psOOq__dealsGridSection",
  "dealsStripSection": "Header-module-scss-module__1psOOq__dealsStripSection",
  "filterBarRow": "Header-module-scss-module__1psOOq__filterBarRow",
  "header": "Header-module-scss-module__1psOOq__header",
  "headerRecommendations": "Header-module-scss-module__1psOOq__headerRecommendations",
  "headerRecommendationsFullWidth": "Header-module-scss-module__1psOOq__headerRecommendationsFullWidth",
  "headerSortBarV2": "Header-module-scss-module__1psOOq__headerSortBarV2",
  "headerStickyFilters": "Header-module-scss-module__1psOOq__headerStickyFilters",
  "mobileFacetButton": "Header-module-scss-module__1psOOq__mobileFacetButton",
  "noRefinementRoot": "Header-module-scss-module__1psOOq__noRefinementRoot",
  "screenReaderOnly": "Header-module-scss-module__1psOOq__screenReaderOnly",
  "searchResultsSort": "Header-module-scss-module__1psOOq__searchResultsSort",
  "searchResultsStats": "Header-module-scss-module__1psOOq__searchResultsStats",
  "searchResultsUI": "Header-module-scss-module__1psOOq__searchResultsUI",
  "statsRoot": "Header-module-scss-module__1psOOq__statsRoot",
  "storeAvailability": "Header-module-scss-module__1psOOq__storeAvailability",
  "titleRhythm": "Header-module-scss-module__1psOOq__titleRhythm",
  "titleV2": "Header-module-scss-module__1psOOq__titleV2",
});
